<template>
	<v-layout wrap mb-5 pb-5>
		<v-flex xs12>
			<h1 class="title-modal">Eliminar Área</h1>
		</v-flex>
		<v-flex xs12 info--text bold-1>
			¿Desea eliminar el área "{{ name }}" del listado?
		</v-flex>
	</v-layout>
</template>

<script>
	export default {
		name: 'delete-area',
		props: {
			name: String,
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/configuration/delete-area.vue